export const driversList = [
  {
    id: 'DRV-101',
    name: 'فهد العتيبي',
    phone: '0551112233',
    status: 'available',
    statusLabel: 'متاح',
    distance: '1.2 كم',
    tasksToday: 8,
    rating: 4.8,
    vehicle: 'دراجة نارية — ح م ب 4521',
    photo:
      'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20a%20friendly%20Arab%20man%20in%20a%20clean%20light%20blue%20uniform%20shirt%2C%20neutral%20bright%20studio%20background%2C%20soft%20even%20lighting%2C%20corporate%20identity%20photo%2C%20sharp%20and%20clear&width=200&height=200&seq=driver-photo-101&orientation=squarish',
  },
  {
    id: 'DRV-102',
    name: 'سلطان الحربي',
    phone: '0554445566',
    status: 'busy',
    statusLabel: 'مشغول',
    distance: '3.4 كم',
    tasksToday: 12,
    rating: 4.6,
    vehicle: 'دراجة نارية — ر س د 8830',
    photo:
      'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20a%20smiling%20Arab%20man%20with%20a%20short%20beard%20wearing%20a%20navy%20polo%20shirt%2C%20clean%20light%20gray%20studio%20background%2C%20soft%20natural%20lighting%2C%20corporate%20identity%20photo%2C%20high%20detail&width=200&height=200&seq=driver-photo-102&orientation=squarish',
  },
  {
    id: 'DRV-103',
    name: 'خالد الزهراني',
    phone: '0557778899',
    status: 'available',
    statusLabel: 'متاح',
    distance: '2.0 كم',
    tasksToday: 5,
    rating: 4.9,
    vehicle: 'سيارة — ط ب ن 1122',
    photo:
      'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20a%20young%20Arab%20man%20in%20a%20white%20shirt%2C%20plain%20soft%20beige%20studio%20background%2C%20warm%20soft%20lighting%2C%20corporate%20identity%20photo%2C%20crisp%20detail&width=200&height=200&seq=driver-photo-103&orientation=squarish',
  },
  {
    id: 'DRV-104',
    name: 'ماجد القحطاني',
    phone: '0552223344',
    status: 'offline',
    statusLabel: 'غير متاح',
    distance: '—',
    tasksToday: 0,
    rating: 4.4,
    vehicle: 'دراجة نارية — ن ب ح 3390',
    photo:
      'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20an%20Arab%20man%20wearing%20a%20light%20gray%20uniform%20shirt%2C%20minimal%20plain%20studio%20background%2C%20soft%20diffused%20lighting%2C%20corporate%20identity%20photo%2C%20clear%20and%20sharp&width=200&height=200&seq=driver-photo-104&orientation=squarish',
  },
  {
    id: 'DRV-105',
    name: 'بندر الشهري',
    phone: '0556667788',
    status: 'available',
    statusLabel: 'متاح',
    distance: '4.6 كم',
    tasksToday: 9,
    rating: 4.7,
    vehicle: 'سيارة — س ر ق 7745',
    photo:
      'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20a%20middle%20aged%20Arab%20man%20with%20a%20clean%20look%20wearing%20a%20blue%20work%20shirt%2C%20simple%20light%20studio%20background%2C%20soft%20even%20lighting%2C%20corporate%20identity%20photo%2C%20high%20clarity&width=200&height=200&seq=driver-photo-105&orientation=squarish',
  },
];

export const driverTasks = [
  {
    id: 'T-2201',
    type: 'استلام',
    orderNo: '#98740',
    date: '2026-09-16',
    time: '09:15 ص',
    fee: '15 ر.س',
  },
  {
    id: 'T-2202',
    type: 'تسليم',
    orderNo: '#98736',
    date: '2026-09-16',
    time: '11:40 ص',
    fee: '15 ر.س',
  },
  {
    id: 'T-2203',
    type: 'استلام',
    orderNo: '#98728',
    date: '2026-09-15',
    time: '04:05 م',
    fee: '12 ر.س',
  },
  {
    id: 'T-2204',
    type: 'تسليم',
    orderNo: '#98719',
    date: '2026-09-15',
    time: '06:30 م',
    fee: '12 ر.س',
  },
  {
    id: 'T-2205',
    type: 'استلام',
    orderNo: '#98705',
    date: '2026-09-14',
    time: '10:20 ص',
    fee: '15 ر.س',
  },
];

export const driverWeeklyTasks = [
  { day: 'السبت', tasks: 14 },
  { day: 'الأحد', tasks: 18 },
  { day: 'الاثنين', tasks: 12 },
  { day: 'الثلاثاء', tasks: 20 },
  { day: 'الأربعاء', tasks: 16 },
  { day: 'الخميس', tasks: 22 },
  { day: 'الجمعة', tasks: 9 },
];